import { createContext } from 'react';

import { Context } from '../../../types';
import { ServiceAttribute } from '../types';
import api from '../api';
import { getContextDefaultValues } from '../../providersDataManager';

const serviceAttributesContext = createContext<Context<ServiceAttribute>>(getContextDefaultValues(api));
export default serviceAttributesContext;
